import config from 'config';
import { createStore } from '@mulesoft/exchange-ui-portals-store';

export default function configureStore(
  errorHandler,
  customMiddlewares,
  initialState,
  session
) {
  return createStore({
    errorHandler,
    customMiddlewares,
    initialState,
    session,
    config
  });
}
